import { LoginRegisterBlocksProps } from '~/components/LoginRegisterBlocks/models';
import { pageBlockUIMapper } from '~/mappers/pageBlock';

import { LoginRegisterBlocks } from './models';

export const LoginRegisterBlocksMapper = ({
  pageBlockUI,
  componentId,
  variant,
  uid,
}: LoginRegisterBlocks): LoginRegisterBlocksProps => ({
  pageBlockUI: pageBlockUIMapper(pageBlockUI[0].ui),
  componentId,
  variant,
  uid,
});
